module.exports = __webpack_public_path__ + "img/banner-escritorio-cover.45eb7a3d.jpeg";